import { Component, Input, OnInit } from '@angular/core';
import { enProgressDisplayText } from './paf-round-progress-svg/paf-round-progress-svg.component';

@Component({
  selector: 'paf-rounded-progress-bar',
  templateUrl: './rounded-progress-bar.component.html',
  styleUrls: ['./rounded-progress-bar.component.scss']
})
export class RoundedProgressBarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  @Input() max?: number=100;
  @Input() current?: number = 0;
  @Input() color?: string = '#45ccce';
  @Input() width: number = 120;
  @Input() height: number = 60;
  @Input() stroke: number = 10;        // épaisseur du trait
  @Input() displayMode: enProgressDisplayText = enProgressDisplayText.ValueAndMax;
  @Input() labelCod?: string;  // code du label à afficher au dessous du graphique

}

